import { GlobalConfig } from "@common/utils";

const { apiUrl, appUrl, baseUrl } = GlobalConfig;

const app = path => `${appUrl}/${path}`;

const GENERAL_API_BASE = apiUrl + "/general/v1";

const PRO_API_BASE = apiUrl + "/pro/v2";

const ACCOUNT_SIGN_IN = "/account/";
const ACCOUNT_SIGN_OUT = "/account/signout";

const NETWORK_API_BASE = "/network/";

export const Routing = {
    Api: {
        General: {
            FILE_DELETE: GENERAL_API_BASE + "/files?fileId=",
            FILE_POST: GENERAL_API_BASE + "/files?fileCategoryType=",
            RESET_PASSWORD: GENERAL_API_BASE + "/account/reset-password",
            EMAIL: GENERAL_API_BASE + "/account/email",
            SIGN_UP_LOOKUPS: GENERAL_API_BASE + "/account/sign-up-lookups",
            SIGN_UP_EXTERNAL: GENERAL_API_BASE + "/account/sign-up-external",
            CONFIRMATION: GENERAL_API_BASE + "/account/confirmation",
            ACTIVATE_USER: GENERAL_API_BASE + "/account/activate/user",
            JOB_POSITIONS_LOOKUP: GENERAL_API_BASE + "/jobpositions/suggest",
            Profile: {
                PROFILE_ACTIVITIES: GENERAL_API_BASE + "/profile/activities",
                SMS_OPT_IN_STATUS: GENERAL_API_BASE + "/profile/sms-status",
                SAVE_AGENT_SETTINGS: GENERAL_API_BASE + "/profile/agent",
                SAVE_NOTIFICATION_SETTINGS:
                    GENERAL_API_BASE + "/profile/notifications",
                SAVE_CONTACT_SETTINGS: GENERAL_API_BASE + "/profile/contact",
                GET_CONTACT_SETTINGS: GENERAL_API_BASE + "/profile/contact",
                GET_NOTIFICATION_SETTINGS:
                    GENERAL_API_BASE + "/profile/notifications",
                GET_AGENT_SETTINGS: GENERAL_API_BASE + "/profile/agent",
                MANAGER: GENERAL_API_BASE + "/profile/manager",
                EARNINGS: GENERAL_API_BASE + "/profile/earnings",
            },
            JobPositions: {
                SUGGEST: GENERAL_API_BASE + "/jobpositions/suggest",
            },
            Locations: {
                SUGGEST: GENERAL_API_BASE + "/locationsuggest",
            },
        },
        Pro: {
            Messages: {
                UNREAD_COUNT: PRO_API_BASE + "/messages/unread/count",
            },
            Invite: {
                INTERESTED: PRO_API_BASE + "/jobcandidates/interest", // POST
            },
            Referrals: {
                ACTIVITIES: PRO_API_BASE + "/jobcandidates/{id}/activities",
                ACTIVITIES_SUMMARY:
                    PRO_API_BASE + "/jobcandidates/{id}/activitiessummary",
                LINK: PRO_API_BASE + "/jobcandidates/link",
                SEARCH: PRO_API_BASE + "/jobcandidatesearch",
                UPDATE: PRO_API_BASE + "/jobcandidates",
                UPDATE_STATUS: PRO_API_BASE + "/jobcandidates/{id}/status",
                DETAILS: PRO_API_BASE + "/jobcandidates/{id}",
                DETAILS_BY_USER_AND_JOB:
                    PRO_API_BASE + "/jobcandidates/{userId}/{jobId}",
                DECLINE_REASONS: PRO_API_BASE + "/jobcandidates/declinereasons",
                VALIDATION_REQUEST:
                    PRO_API_BASE + "/jobcandidates/refer/validations",
            },
            Applications: {
                SEARCH: PRO_API_BASE + "/applicationsearch",
                UPDATE: PRO_API_BASE + "/applications",
            },
            Jobs: {
                CATEGORIES: PRO_API_BASE + "/jobs/categories",
                DETAILS: PRO_API_BASE + "/jobs/{id}",
                LEAVE: PRO_API_BASE + "/jobs/{id}/users",
                SEARCH: PRO_API_BASE + "/jobsearch",
                SUGGEST: PRO_API_BASE + "/jobsuggest",
                RECOMMENDED_JOBS: PRO_API_BASE + "/jobs/recommended",
            },
            Friends: {
                SEARCH: PRO_API_BASE + "/friendsearch",
            },
            Settings: {
                GET_PAYMENTS_URL: PRO_API_BASE + "/settings/paymentsurl",
                GET_PAYMENTS_HISTORY_URL:
                    PRO_API_BASE + "/settings/paymentshistoryurl",
            },
        },
    },
    Network: {
        CANDIDATE_VERIFICATION:
            NETWORK_API_BASE + "public/candidate/verification",
        CANDIDATE_INTEREST: NETWORK_API_BASE + "/public/candidate/interest",
    },

    Marketing: {
        POLICY_TERMS: "https://www.relode.com/terms",
        POLICY_PRIVACY: "https://www.relode.com/privacy",
    },
    Social: {
        RELODE_REDIRECT_KEY: "relode:redirectUrl",
        HOST_AND_PORT: GlobalConfig.appUrl,
    },
    Client: {
        ROOT: "/",

        Account: {
            SIGN_IN: ACCOUNT_SIGN_IN,
            SIGN_IN_SESSION_EXPIRED: ACCOUNT_SIGN_OUT,
            SIGN_OUT: ACCOUNT_SIGN_OUT,
        },
        Jobs: {
            SEARCH: "/",
            DETAILS: "/jobs/:id",
            INVITE: "/invite/:id",
            VERIFICATION: "/verification",
            NOT_FOUND: "/not-found",
            ERROR: "/error",
        },
        Pro: {
            BASE: "/pro",
            Home: {
                DASHBOARD: "/",
            },
            Jobs: {
                SEARCH: "/jobs",
                DETAILS: "/jobs/:id",
            },
            Applications: {
                SEARCH: "/applications",
                DETAILS: "/applications/:id",
                ACTIVITY: "/applications/:id/activity",
            },
            Referrals: {
                SEARCH: "/referrals",
                DETAILS: "/referrals/:id",
                DETAILS_BY_USER_AND_JOB: "/referrals/:userid/:jobid",
                ACTIVITY: "/referrals/:id/activity",
            },
            Error: {
                OOPS: "/error",
                NOT_FOUND: "/not-found",
            },
            Dashboard: {
                HOME: "/",
            },
            Profile: {
                SETTINGS_PANE: "/profile/settings/:pane?",
                Panes: {
                    CONTACT_INFO: "contact-info",
                    PASSWORD: "password",
                    SOCIAL_NETWORKS: "social-networks",
                    NOTIFICATIONS: "notifications",
                    AGENT_SETTINGS: "agent-settings",
                    PAYMENT_INFORMATION: "payments",
                    PAYMENT_HISTORY: "payment-history",
                    PAYMENT_HISTORY_ROUTE: "/profile/settings/payment-history",
                },
                ACTIVITY: "/profile/activity",
                FRIENDS: "/profile/friends",
            },
            Messages: {
                SEARCH: "/messages",
            },
        },
    },
    Mvc: {
        LOGO_OG: "https://go.relode.com/Content/images/logo-og.png",
    },
};
